<template>
  <div class="article-box">
    <h5 class="article_title">联系我们</h5>
    <hr>

    <div class="article_content" v-html="data">
      <!--<p><img width="100%" src="../assets/img.jpg" title="12.jpg" alt="12.jpg">
        <img width="100%" src="../assets/img.jpg" title="联系我们 (2).jpg" alt="联系我们 (2).jpg">
        <img width="100%" src="../assets/img.jpg" title="联系我们 (5) (2).jpg" alt="联系我们 (5) (2).jpg">
        <img width="100%" src="../assets/img.jpg" title="43.jpg" alt="43.jpg">
        <img width="100%" src="../assets/img.jpg" title="58.jpg" alt="58.jpg">
        <img width="100%" src="../assets/img.jpg" title="6.jpg" alt="6.jpg"></p>-->
    </div>
    <!---->


    <!--                    -->
  </div>
</template>

<script>
    export default {
        name: "helpcontact",
      data(){
        return{
          data:''
        }
      },
      methods:{
        getData(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                'nozzle': 'protocol',
                'type': 10,
              }
            })  .then(res => {
            let resData = res.data;
            if (res.data.code == 1) {
              that.data = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
        }
      },
      mounted() {
        this.getData();
      }
    }
</script>

<style scoped>
  .article_title{
    font-size: 20px;
    font-weight: 500;
  }
  .article_content>>>img{
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/helpcontact.vue